import "bootstrap/dist/css/bootstrap.min.css";
import AppRouter from "./router/AppRouter";

function App() {
  return (
    <div>
      <AppRouter />
    </div>
  );
}

export default App;
